import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SharedButton from '../../components/Shared/SharedButton';
import CreateVendor from './CreateVendor';
import VendorTable from './VendorTable';
import { debounce } from '../../helpers/debounce';
import { useNavigate } from 'react-router-dom';
import SearchField from '../../components/Shared/SearchField';
import useFetchData from '../../hooks/useFetchData';

export default function VendorMain() {
  const [createDialogVisible, setCreateDialogVisible] = useState(false);
  const { data: vendorData, loading, executeFetch } = useFetchData();
  const { t } = useTranslation();
  const [searchValue, setSearchValue] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    executeFetch("POST", "list_vendor", { page: 1, per_page: 10 });
  }, [executeFetch]);

  const handlePageChange = (newPage, newRowsPerPage) => {
    executeFetch("POST", "list_vendor", {
      page: newPage,
      per_page: newRowsPerPage,
      query: searchValue.trim() || undefined
    });
  };

  const handleRefresh = () => {
    executeFetch("POST", "list_vendor", {
      page: 1,
      per_page: 10,
      query: searchValue.trim() || undefined
    });
  };

  const handleSearch = event => {
    const value = event?.target?.value;
    setSearchValue(value);
    debouncedSearch(value);
  };

  const handleClearSearch = () => {
    setSearchValue('');
    executeFetch("POST", "list_vendor", { page: 1, per_page: 10 });
  };

  const debouncedSearch = useCallback(
    debounce(value => {
      executeFetch("POST", "list_vendor", {
        query: value?.trim() || undefined,
        page: 1,
        per_page: 10
      });
    }, 500),
    [executeFetch]
  );

  return (
    <>
      <div>
        <div className='flex justify-end mb-2'>
          <div className='flex items-center gap-2'>
            <div className='flex gap-2'>
              <SearchField
                className="w-full md:!w-[300px]"
                placeholder={t(' Search by Name')}
                value={searchValue}
                onChange={handleSearch}
                handleClearClick={handleClearSearch}
              />
            </div>

            <SharedButton
              label={t('CreateVendor')}
              icon='pi pi-plus'
              onClick={() => navigate('/manager/vendor/create')}
              className='bg-primary primary-btn'
            />
          </div>
        </div>
        <VendorTable
          data={vendorData}
          loading={loading}
          onPageChange={handlePageChange}
          onRefresh={handleRefresh}
        />
        <CreateVendor
          setCreateDialogVisible={setCreateDialogVisible}
          createDialogVisible={createDialogVisible}
          onRefresh={handleRefresh}
        />
      </div>
    </>
  );
}
